module.exports = __webpack_public_path__ + "static/img/2013-B.485b0e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2013-B.png
// module id = luXU
// module chunks = 1